import { normalizeProviderKey } from "./provider-catalog";

/** Local platform silhouettes rendered in the surrounding text color. Provenance lives in public/integration-logos/SOURCES.md. */
export const PLATFORM_LOGOS = {
  "brand-ga4": { label: "Google Analytics", file: "google-analytics.svg" },
  "brand-gsc": { label: "Google Search Console", file: "google-search-console.svg" },
  "brand-google-ads": { label: "Google Ads", file: "google-ads.svg" },
  "brand-gbp": { label: "Google Business Profile", file: "google-business.svg" },
  "brand-meta": { label: "Meta", file: "meta.svg" },
  "brand-facebook": { label: "Facebook", file: "facebook.svg" },
  "brand-instagram": { label: "Instagram", file: "instagram.svg" },
  "brand-linkedin": { label: "LinkedIn", file: "linkedin.svg" },
  "brand-hubspot": { label: "HubSpot", file: "hubspot.svg" },
  "brand-callrail": { label: "CallRail", file: "callrail.png" },
  "brand-stackadapt": { label: "StackAdapt", file: "stackadapt.svg" },
  "brand-wordpress": { label: "WordPress", file: "wordpress.svg" },
  "brand-joomla": { label: "Joomla", file: "joomla.svg" },
  "brand-cloudways": { label: "Cloudways", file: "cloudways.svg" },
} as const;

export type PlatformIconKey = keyof typeof PLATFORM_LOGOS;
const PROVIDER_LOGOS: Record<string, PlatformIconKey> = {
  ga4: "brand-ga4", gsc: "brand-gsc", gsc_index: "brand-gsc", google_ads: "brand-google-ads", gbp: "brand-gbp",
  meta_ads: "brand-meta", social_meta: "brand-facebook", social_instagram: "brand-instagram",
  social_linkedin: "brand-linkedin", hubspot: "brand-hubspot", hubspot_email: "brand-hubspot",
  callrail: "brand-callrail", stackadapt: "brand-stackadapt", wordpress: "brand-wordpress",
  joomla: "brand-joomla", cloudways: "brand-cloudways",
};

export function platformIconForProvider(provider: string): PlatformIconKey | undefined {
  return PROVIDER_LOGOS[normalizeProviderKey(provider)];
}
export function isPlatformIconKey(icon: string): icon is PlatformIconKey {
  return Object.hasOwn(PLATFORM_LOGOS, icon);
}
